import { render, staticRenderFns } from "./CustomerDemo.vue?vue&type=template&id=0ec742a7&scoped=true"
import script from "./CustomerDemo.vue?vue&type=script&lang=js"
export * from "./CustomerDemo.vue?vue&type=script&lang=js"
import style0 from "./CustomerDemo.vue?vue&type=style&index=0&id=0ec742a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec742a7",
  null
  
)

export default component.exports